import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatSnackBar } from '@angular/material/snack-bar';
import { SellContract } from '../player-auction.type';

@Component({
  selector: 'app-sell-contract-info-dialog',
  imports: [
    CommonModule,
    MatDialogModule,
    MatButtonModule,
    MatIconModule,
  ],
  templateUrl: './sell-contract-info-dialog.html',
  styleUrl: './sell-contract-info-dialog.scss',
})
export class SellContractInfoDialog {
  readonly dialogRef = inject(MatDialogRef<SellContractInfoDialog>);
  readonly data = inject<{ contract: SellContract }>(MAT_DIALOG_DATA);
  private snackBar = inject(MatSnackBar);

  close() {
    this.dialogRef.close();
  }

  formatDate(d: string | undefined): string {
    if (!d) return 'N/A';
    return new Date(d).toLocaleString();
  }

  formatCoins(n: number | undefined | null): string {
    if (n == null) return 'N/A';
    if (n >= 1_000_000) return (n / 1_000_000).toFixed(2) + 'M';
    if (n >= 1000) return (n / 1000).toFixed(1) + 'K';
    return n.toString();
  }

  formatToman(n: number | undefined | null): string {
    if (n == null) return 'N/A';
    return n.toLocaleString('en-US');
  }

  copyToClipboard(text: string) {
    navigator.clipboard.writeText(text).then(() => {
      this.snackBar.open('Copied!', undefined, { duration: 1500 });
    });
  }
}
